module.exports = __webpack_public_path__ + "img/90a7624.webp";